/*
 * @Description: 模板案例
 * @Author: your name
 * @Date: 2021-08-05 19:04:22
 * @LastEditTime: 2021-08-11 17:24:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 */

import http from "@/plugin/axios";
// import { Apis } from '../index';
import { getSubName } from "@/utils/getHost";
export default {
  /**
   * 获取活动分页模板
   */
  getPageWxAppletTemplate: (data: any): Promise<any> => {
    return http.post("activity/vote/getPageWxAppletTemplate", data);
  },
  /**
   * 官网案例
   */
  getVoteCaseList: (data: any): Promise<any> => {
    return http.post("activity/vote/getVoteCaseList", data);
  },
  /**
   * 官网案例详情
   */
  getVoteCaseDetail: (data: any): Promise<any> => {
    if (getSubName() == "wenjuanjia") {
      data.appletSource = 7;
    }
    return http.post("activity/vote/getVoteCaseDetail", data);
  },
  /**
   * 官网保存意见/建议
   */
  saveOrUpdateFeedBack: (data: any): Promise<any> => {
    return http.post("wxApplet/article/saveOrUpdateFeedBack", data);
  },
  /**
   * pc-问卷官网--问卷模板
   */
  getWxQuestionTemplateList: (data: any): Promise<any> => {
    return http.post("/activity/question/getWxQuestionTemplateList", data);
  },
  /**
   * pc--官网模板--模板类型
   */
  getWxQuestionTemplateTypeList: (data: any): Promise<any> => {
    return http.post("/activity/question/getWxQuestionTemplateTypeList", data);
  },
  /**
   * pc--上下案例
   */
  getLastOrNext: (data: any): Promise<any> => {
    if (getSubName() == "longyixiu") {
      data.systemSource = 1;
    } else if (getSubName() == "wenjuanjia") {
      data.systemSource = 7;
    }
    return http.post("/activity/vote/getLastOrNext", data);
  },
  /**
   * 投票活动点赞
   */
  getVotePraise: (data: any): Promise<any> => {
    return http.post("/activity/vote/getVotePraise", data);
  },
  /**
   * 模板搜索
   */
  getHotTemplateSearchPage: (data: any): Promise<any> => {
    return http.post("/active/template/getHotTemplateSearchPage", data);
  },
};
